import React from "react";
import ToggleButton from "./ToggleButton";
import Navbar from "./Navbar";

export default function NavbarComplete({
  loginButtonText = "ورود",
  loginButtonGradient = "gradient-class",
  signupButtonText = "ثبت نام",
  signupButtonGradient = "gradient-class",
  signupTextColor = "text-color-class",
  signupBorder = "border-class",
  signupPadding = "padding-class",
  loginUrl = "https://crm.spadserver.com/register.php", 
  signupUrl = "https://crm.spadserver.com/login",
}) {
  return (
    <div>
      <div className="block md:hidden">
        <ToggleButton
          loginButtonText={loginButtonText}
          loginButtonGradient={loginButtonGradient}
          signupButtonText={signupButtonText}
          signupButtonGradient={signupButtonGradient}
          signupTextColor={signupTextColor}
          signupBorder={signupBorder}
          signupPadding={signupPadding}
          loginUrl={loginUrl}
          signupUrl={signupUrl}
        />
      </div>
      <div className="hidden md:block">
        <Navbar
          loginButtonText={loginButtonText}
          loginButtonGradient={loginButtonGradient}
          signupButtonText={signupButtonText}
          signupButtonGradient={signupButtonGradient}
          signupTextColor={signupTextColor}
          signupBorder={signupBorder}
          signupPadding={signupPadding}
          loginUrl={loginUrl}
          signupUrl={signupUrl}
        />
      </div>
    </div>
  );
}
